<template>
  <div class="card">
    <router-link :to="`/articles/`">
      <h6 class="card-header with-elements d-flex justify-content-between">
        <span class="card-header-title">
          <i class="fa fa-newspaper text-cr-red mr-2"></i>
          {{ $t('phrase.news_and_articles') }}
        </span>
      </h6>
    </router-link>
    <div v-for="article in articles" :key="article.slug">
      <router-link :to="`/articles/${article.slug}`">
        <div
          class="card-body clickable flex flex-column p-4"
        >
          <h5>
            {{ article.title }}
          </h5>
          <img
            :src="article.image || require('@/common/assets/img/logo.png')"
            class="img-lg img img-thumbnail"
            alt="logo"
          >
          <div class="text-secondary mt-2">
            <small class="text-cr-red">
              {{ stringToPrettyDate(article.created_at) }} |
            </small>
            {{ article.truncated_summary }}
          </div>
        </div>
      </router-link>
      <hr v-if="hasMore" />
    </div>
    <router-link :to="`/articles/`">
      <div class="d-flex justify-content-center mb-3">
        {{ $t('phrase.view_all_articles') }}
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { stringToPrettyDate } from '@/common/utils/formatting';

export default {
  name: 'ArticlesCard',
  created() {
    this.getDashboardArticles();
  },
  data() {
    return {
      hasMore: false,
    };
  },
  computed: {
    ...mapGetters('sites', {
      articles: 'dashboardArticles',
    }),
  },
  methods: {
    async getDashboardArticles() {
      const res = await this.$store.dispatch('sites/getDashboardArticles');
      this.hasMore = res.data.next !== null;
    },
    stringToPrettyDate,
  },
};
</script>
